module.exports = __webpack_public_path__ + "fonts/21ca819a-38ec-4f58-92d9-107d0f271416.56fd941b.woff";